export default {
  blank: () => import("/app/app/platform/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/app/app/platform/layouts/default.vue").then(m => m.default || m),
  exposed: () => import("/app/app/platform/layouts/exposed.vue").then(m => m.default || m),
  "h5-us": () => import("/app/app/platform/layouts/h5-us.vue").then(m => m.default || m),
  h5: () => import("/app/app/platform/layouts/h5.vue").then(m => m.default || m),
  "landing-us": () => import("/app/app/platform/layouts/landing-us.vue").then(m => m.default || m),
  landing: () => import("/app/app/platform/layouts/landing.vue").then(m => m.default || m),
  transition: () => import("/app/app/platform/layouts/transition.vue").then(m => m.default || m)
}